export default "__VITE_ASSET__8ely9BnL__"